<template>
  <div class="footer">
    <div class="ft_help">
      <!--            <p>FEATURE CATEGORIES</p>-->
      <!-- <div class="order_search">
                <form action="">
                    <van-search v-model="order_no" show-action background="#f5f6f8" placeholder="Order inquiry">
                        <template #action>
                            <div @click="searchOrder">
                                <van-button type="primary" size="small">Inquire</van-button>
                            </div>
                        </template>
                    </van-search>
                </form>
            </div> -->
      <van-collapse v-if="nav_footer != ''" v-model="foothelp" accordion style="margin-bottom: 20px;">
                <div v-for="(value,index) in nav_footer" :key="index" >
                    <van-collapse-item :title="value.name" :name="index">
                        <div class="footer_list">
                            <span v-for="(value1,index1) in value.items" :key="index1">
                                <template v-if="value1.data_type == 'article'">
                                    <router-link :to="{path:'/help', query:{id: value1.value}}">
                                        <span v-html="value1.name"></span>
                                    </router-link>
                                </template>
                                <template v-if="value1.data_type == 'custom'">
                                    <a :href="value1.url">
                                        <span v-html="value1.name"></span>
                                    </a>
                                </template>
                                <template v-if="value1.data_type == 'other'">
                                    <a :href="value1.url">
                                        <span v-html="value1.name"></span>
                                    </a>
                                </template>
                            </span>
                        </div>
                    </van-collapse-item>
                </div>
            </van-collapse>
      <div class="footer_list">
          <img src="../assets/icon.png" alt="" />
      </div>
      <div class="foot_payimg">
        <a href="https://b.alipay.com/page/portal/home" target="_blank"><img src="../assets/ty_1.png" alt="" /></a>
        <a href="https://www.hnwx.gov.cn/wxzw/" target="_blank"><img src="../assets/ty_2.png" alt="" /></a>
        <a href="https://www.12377.cn/" target="_blank"><img src="../assets/ty_3.png" alt="" /></a>
        <a href="https://www.12315.cn/" target="_blank"><img src="../assets/ty_5.png" alt="" /></a>
        <a href="" target="_blank"><img src="../assets/ty_4.png" alt="" /></a>
      </div>
      <div class="foot_bq" :style="{marginBottom: !$route.meta.detailsHide?'20px':'60px'}">
        <p>为了防范电信网络诈骗，如网民接到962110电话，请立即接听 </p>
        <p>重庆集刻码域科技有限公司</p>
        <p><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" >渝ICP备2025068077号-1</a></p>
        <p>联系我们：maogepaoba@sina.com</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      foothelp: "",
      nav_footer: [],
      order_no: "",
    };
  },
  created() {
    var _self = this;
    setTimeout(function () {
      _self.nav_footer = window.nav_footer;
    }, 1000);
  },
  methods: {
    searchOrder() {
      if (this.order_no == "") {
        this.$toast("请填写订单号");
        return false;
      }

      this.$router.push({
        path: "searchorder",
        query: { order_no: this.order_no },
      });
    },
  },
};
</script>
<style>
.footer .van-hairline--top-bottom::after,
.footer .van-hairline-unset--top-bottom::after {
  border: none;
}

.ft_help {
  width: 100%;
  margin-top: 30px;

  /* background-color: #f5f6f8; */
}

.footer_list span {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  padding: 3px 16px;
  overflow: hidden;
  color: #333;
  font-size: 14px;
  line-height: 24px;
  background-color: #fff;
  border-bottom: 1px solid #f5f8fb;
}

.footer_list span:last-child {
  border-bottom: none;
}

.footer .van-collapse-item .van-cell {
  background-color: #f5f6f8;
  color: #333;
  padding: 10px 0;
}

.footer .van-cell__right-icon {
  color: #9e9e9e;
  margin-right: 16px;
}

.footer .van-cell::after,
.footer .van-collapse-item--border::after {
  left: 0;
  right: 0;
}

.footer .van-collapse-item__content {
  padding: 0;
}

.order_search {
  width: 100%;
  background-color: #f5f6f8;
  color: #333;
  /* padding: 10px 0; */
  border-bottom: 1px solid #ebedf0;
}

.order_search .van-search__content {
  background-color: #fff;
}
.footer_list{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 10px;
}
.footer_list img{
  width: 100%;
  height: auto;
}
.foot_payimg{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 20px 10px;
}
.foot_payimg a{
  width: 19%;
}
.foot_payimg img{
  width: 100%;
  height: auto;
}
.foot_bq {
  font-size: 12px;
  color: #333;
  margin-bottom: 10px;
}
.foot_bq p{
  padding: 0;
  margin: 0;
  margin-bottom: 3px;
}
.foot_bq a,.foot_bq a:hover,.foot_bq a:active,.foot_bq a:visited{
  color: #333;
}
</style>